export class Offset {
  index = 0
  limit = 30
}
